<div class="card bg-success" *ngIf="cargoheadbar">
  <div class="card-body">
    <div class="media faq-widgets">
      <div class="media-body">
        <!-- <i data-feather="file-text"></i> -->
        <h2>Monitor Financiero</h2>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-2">
            <h2>Año</h2>
          </div>
          <div class="col-2">
            <select class="form-control form-control-lg" [(ngModel)]="ano">
              <option *ngFor="let i of iterano" [value]="2022 - i">
                {{ 2022 - i }}
              </option>
            </select>
          </div>
          <div class="col-2">
            <h2>Periodo</h2>
          </div>
          <div class="col-2">
            <select class="form-control form-control-lg" [(ngModel)]="periodo">
              <option *ngFor="let i of itermes" [value]="i">
                {{ i }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="btn-group">
  <div class="row">
    <div class="col">
      <kendo-splitbutton
        (buttonClick)="onPaste()"
        [data]="monitores"
        icon="paste"
      >
        Monitores
      </kendo-splitbutton>
    </div>
    <div class="col">
      <kendo-splitbutton
        (buttonClick)="onPaste()"
        [data]="reportes"
        icon="paste"
      >
        Reportes
      </kendo-splitbutton>
    </div>
    <div class="col">
      <kendo-splitbutton
        (buttonClick)="onPaste()"
        [data]="personalizados"
        icon="paste"
      >
        Personalizados
      </kendo-splitbutton>
    </div>
    <div class="col">
      <kendo-splitbutton
        (buttonClick)="onPaste()"
        [data]="procesos"
        icon="paste"
      >
        Procesos
      </kendo-splitbutton>
    </div>
  </div>
</div>

<br />
<br />
